import EditBase from "../EditBase"

class EditWall extends EditBase {

    constructor(options) {
        super(options);
    }


    initProperty() {
        var $this = this;
        var attr = $this.plot.wall.attr;
        var positionsProperty = new $this.Cesium.CallbackProperty(function () {
            return $this.plot.attrPlot["edit_positions"];
        }, false);

        var minimumHeights = new $this.Cesium.CallbackProperty(function () {
            var positions = $this.plot.attrPlot["edit_positions"];
            var list = new Array(positions.length);
            for (var i = 0; i < positions.length; i++) {
                var carto = Cesium.Cartographic.fromCartesian(positions[i]);
                var heightTerrain = $this.viewer.scene.globe.getHeight(carto);
                list[i] = heightTerrain;
            }

            return list;

        })

        var maximumHeights = new $this.Cesium.CallbackProperty(function () {
            var positions = $this.plot.attrPlot["edit_positions"];
            var list = new Array(positions.length);
            for (var i = 0; i < positions.length; i++) {
                var carto = Cesium.Cartographic.fromCartesian(positions[i]);
                var heightTerrain = $this.viewer.scene.globe.getHeight(carto);
                if ($this.plot.attrPlot["edit_extrudedHeight"]) {
                    list[i] = $this.plot.attrPlot["edit_extrudedHeight"].getValue();
                }
                else {

                    if (attr && attr.maximumHeights) {
                        list[i] = attr.maximumHeights[i];
                    }
                    else {
                        list[i] = (heightTerrain + $this.drawBase.maximumHeights);
                    }

                }
            }

            return list;

        })

        this.plot.wall.positions = positionsProperty;
        this.plot.wall.minimumHeights = minimumHeights;
        this.plot.wall.maximumHeights = maximumHeights;
    }


    heightMoveAll(endPosition, startPosition) {
        var $this = this;
        var zOffset = new Cesium.Cartesian3();
        //改变高度垂直拖动
        var dy = endPosition.y - startPosition.y;

        var position = $this.heightPos.position.getValue();
        //获取该点的投影面
        var tangentPlane = new Cesium.EllipsoidTangentPlane(position);
        var scratchBoundingSphere = new Cesium.BoundingSphere(); //包围球体
        scratchBoundingSphere.center = position;
        scratchBoundingSphere.radius = 1;

        //获取像素大小-米
        var metersPerPixel = $this.viewer.scene.frameState.camera.getPixelSize(scratchBoundingSphere, $this.viewer.scene.frameState.context.drawingBufferWidth, $this.viewer.scene.frameState.context.drawingBufferHeight);
        var heightDiff = -dy * metersPerPixel;
        Cesium.Cartesian3.multiplyByScalar(tangentPlane.zAxis, heightDiff, zOffset);
        var newPosition = Cesium.Cartesian3.clone(position);
        Cesium.Cartesian3.add(position, zOffset, newPosition);

        //更新开始
        var oldHeight = $this.plot.wall.maximumHeights.getValue()[0] || 0;

        console.log("oldHeight" + oldHeight);
        console.log("heightDiff" + heightDiff);

        $this.heightPos.position.setValue(newPosition);
        $this.plot.attrPlot["edit_extrudedHeight"] = {
            getValue: () => {
                return oldHeight + heightDiff;
            }
        };

    }

}


export default EditWall;